module.exports = require("@swa-ui/design-tokens/src/generated/platforms/scss/helpcenter-dark.module.scss");